// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_WIKI_ARTICLE_EXPERIENCES = ["%(count)s sk\u00fasenos\u0165", "%(count)s sk\u00fasenosti", "%(count)s sk\u00fasenost\u00ed"];
export const WIKI_WRITE_YOUR_FIRST_EXPERIENCE = "Bu\u010f prv\u00e1 a nap\u00ed\u0161 hodnotenie";
